import ExternalApiRequest from "./../utils/ExternalApiRequest";
import actionTypes from "./../constants/actionTypes";
import { getList } from "./formActions";
import { toast } from 'react-toastify';
import { cleanObject } from "../utils/utility";

export const listTrackings = (requestPayload, listFormKey) => {
    try {
        return async (dispatch, getState) => {
            const { forms = {} } = getState();
            const { formJson = {} } = forms;
            const formData = formJson[listFormKey] || {}
            const listResponse = await getList(requestPayload, "listTracking", "trackings");
            const listJson = formListJson(formData, listResponse);
            return dispatch({
                type: actionTypes.TRACKING.TRACKING_LIST,
                payload: listJson,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

const formListJson = (formPayload, listPayload) => {
    const { data = {}, meta = {} } = formPayload;
    const { trackings = [], meta: listMeta = {} } = listPayload;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const listData = trackings.map(tracking => {
        const { additionalInfo = {}, status = '', actions = [] } = tracking;
        const { telegramAlert = false, qty = 0, sellConditions = [] } = additionalInfo;
        const rowData = fields.reduce((accum, field, index) => {
            let value = '';
            switch (field.id) {
                case "action": {
                    value = actions.map(action => action.toLowerCase())
                    break;
                }
                case "telegramAlert": {
                    value = telegramAlert ? 'Enabled' : 'Disabled';
                    break;
                }
                case "qty": {
                    value = qty;
                    break;
                }
                case "sellConditions": {
                    value = sellConditions.join(", ");
                }
                default: value = tracking[field.id] || additionalInfo[field.id] || '';
            }
            return { ...accum, [field.id]: value };
        }, {});
        return rowData;
    });
    return { headers: fields, data: listData, meta };
}

export const deleteTracking = (requestPayload) => {
    try {
        return async (dispatch, getState) => {
            const { trackingId = '' } = requestPayload;
            const options = {
                api: "deleteTracking",
                urlAppend: `/${trackingId}`
            };
            const response = await ExternalApiRequest(options);
            const { status = {} } = response;
            const { success = false } = status;
            const { tracking = {} } = getState();
            const { listing = {} } = tracking;
            const { data = [] } = listing;
            const updatedData = data.filter(datum => {
                return datum.trackingId != requestPayload.trackingId;
            });
            if (success) {
                toast.success('Successfully Deleted');
                return dispatch({
                    type: actionTypes.TRACKING.TRACKING_LIST,
                    payload: {
                        ...listing,
                        data: updatedData
                    },
                });
            } else {
                toast.error('Deletion failed');
                return dispatch({ type: '', payload: {} });
            }
        }
    } catch (error) {
        console.log(error);
    }
}

export const enableTracking = (requestPayload) => {
    try {
        return async (dispatch, getState) => {
            const { trackingId = '', enabled = false } = requestPayload;
            const options = {
                api: "enableTracking",
                urlAppend: `/${trackingId}/${enabled}`
            };
            const response = await ExternalApiRequest(options);
            const { status = {} } = response;
            const { success = false } = status;
            const { tracking = {} } = getState();
            const { listing = {} } = tracking;
            const { data = [] } = listing;
            const updatedData = data.map(datum => {
                if (datum.trackingId == requestPayload.trackingId)
                    return { ...datum, ...requestPayload };
                return datum;
            });
            if (success) {
                toast.success('Successfully Updated');
                return dispatch({
                    type: actionTypes.TRACKING.TRACKING_LIST,
                    payload: {
                        ...listing,
                        data: updatedData
                    },
                });
            } else {
                toast.error('Updation failed');
                return dispatch({ type: '', payload: {} });
            }
        }
    } catch (error) {
        console.log(error);
    }
}

export const saveTracking = (requestPayload) => {
    try {
        return async (dispatch, getState) => {
            const options = {
                api: "saveTracking",
                content: cleanObject(requestPayload, [null, ""])
            };
            const response = await ExternalApiRequest(options);
            const { status = {} } = response;
            const { success = false } = status;
            if (success) {
                toast.success('Successfully Submitted');
            }
            return dispatch({
                type: actionTypes.TRACKING.SAVE_TRACKING,
                payload: response,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const emptySaveResponse = () => {
    try {
        return async (dispatch) => {
            return dispatch({
                type: actionTypes.TRACKING.SAVE_TRACKING,
                payload: {},
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const emptyListing = () => {
    try {
        return async (dispatch) => {
            return dispatch({
                type: actionTypes.TRACKING.TRACKING_LIST,
                payload: {},
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const getTracking = (trackingId) => {
    try {
        return async (dispatch) => {
            const options = {
                api: "listTracking",
                content: { trackingId }
            };
            const response = await ExternalApiRequest(options);
            const { payload = {}, status = {} } = response;
            const { trackings = [] } = payload;
            const [tracking = {}] = trackings;
            return dispatch({
                type: actionTypes.TRACKING.GET_TRACKING,
                payload: tracking,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const emptyGetTracking = () => {
    try {
        return async (dispatch) => {
            return dispatch({
                type: actionTypes.TRACKING.GET_TRACKING,
                payload: {},
            });
        }
    } catch (error) {
        console.log(error);
    }
}